// Server-safe glass tokens. glass-kit.tsx is a client module, so route files
// (server components) can't read THEME from it; the canvas colour lives here.
// Ink, not black: #050506 read as a void on phones. The footer stays
// true black (#000) so the page still has an end.
export const GLASS_DARK_BG = "#0B0B0D"
export const GLASS_LIGHT_BG = "#EFEDE7"
